"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var base_measure_context_exports = {};
__export(base_measure_context_exports, {
  BaseMeasureContext: () => BaseMeasureContext
});
module.exports = __toCommonJS(base_measure_context_exports);
var import_context_utils = require("./context-utils");
var import_metrics = require("./metrics");
class BaseMeasureContext {
  constructor(name, params, fullParams, metrics, logger, parent, logParams, logLevel) {
    this.name = name;
    this.params = params;
    this.metrics = metrics;
    this.parent = parent;
    this.logParams = logParams;
    this.logLevel = logLevel;
    this.fullParams = typeof fullParams === "function" ? () => {
      this.fullParams = import_metrics.EMPTY_PARAMS;
      try {
        const resolved = fullParams();
        this.fullParams = resolved;
        return resolved;
      } catch (error) {
        (0, import_context_utils.reportTelemetryFailure)(error);
        return import_metrics.EMPTY_PARAMS;
      }
    } : fullParams;
    this.contextData = parent !== void 0 ? parent.contextData : {};
    (0, import_metrics.updateNamedParams)(metrics.namedParams ??= {}, params);
    this.logger = logger ?? (logParams != null ? (0, import_context_utils.consoleLogger)(logParams) : import_context_utils.noParamsLogger);
  }
  static {
    __name(this, "BaseMeasureContext");
  }
  fullParams;
  logger;
  id;
  contextData;
  st = (0, import_context_utils.platformNow)();
  isDone = false;
  duration = 0;
  newChild(name, params, opt) {
    const child = this.createChild(name, params, opt?.fullParams, opt, opt?.span);
    child.id = this.id;
    return child;
  }
  operationChild(name, params, fullParams, opt) {
    const child = this.createChild(
      name,
      opt?.inheritParams === true ? { ...this.params, ...params } : params,
      fullParams,
      opt,
      opt?.span ?? true
    );
    child.id = this.id;
    return child;
  }
  runOperation(op) {
    return op(this);
  }
  with(name, params, op, fullParams, opt) {
    const child = this.operationChild(name, params, fullParams, opt);
    let result;
    let asynchronous;
    try {
      result = child.runOperation(op);
      asynchronous = (0, import_context_utils.isThenable)(result);
    } catch (error) {
      child.onFinish(opt, true, error);
      throw error;
    }
    if (!asynchronous) {
      child.onFinish(opt, false);
      return result == null ? import_context_utils.nullPromise : Promise.resolve(result);
    }
    return Promise.resolve(result).then(
      (value) => {
        child.onFinish(opt, false);
        return value;
      },
      (error) => {
        child.onFinish(opt, true, error);
        throw error;
      }
    );
  }
  withSync(name, params, op, fullParams, opt) {
    const child = this.operationChild(name, params, fullParams, opt);
    let result;
    try {
      result = child.runOperation(op);
    } catch (error) {
      child.onFinish(opt, true, error);
      throw error;
    }
    child.onFinish(opt, false);
    return result;
  }
  onFinish(opt, _failed, _error) {
    try {
      this.end();
      if (opt?.log === true) {
        const duration = Math.round(this.duration * 100) / 100;
        this.logger.logOperation(this.name, duration, { ...this.params, ...this.getFullParams() });
      }
    } catch (error) {
      (0, import_context_utils.reportTelemetryFailure)(error);
    }
  }
  done(value, override) {
    if (this.isDone) return;
    this.isDone = true;
    const endedAt = (0, import_context_utils.platformNow)();
    this.duration = endedAt - this.st;
    try {
      (0, import_metrics.updateMeasure)(this.metrics, this.st, this.params, this.fullParams, void 0, value, override, endedAt);
    } catch (error) {
      (0, import_context_utils.reportTelemetryFailure)(error);
    }
    try {
      this.onEnd();
    } catch (error) {
      (0, import_context_utils.reportTelemetryFailure)(error);
    }
  }
  onEnd() {
  }
  end(value) {
    this.done(value);
  }
  getFullParams() {
    return typeof this.fullParams === "function" ? this.fullParams() : this.fullParams;
  }
  getParams() {
    return this.params;
  }
  onLog(level, message, args) {
  }
  log(level, message, args) {
    if (level === "debug" && this.logLevel !== "debug") return;
    try {
      this.onLog(level, message, args);
    } catch (error) {
      (0, import_context_utils.reportTelemetryFailure)(error);
    }
    try {
      this.logger[level](message, { ...this.params, ...this.logParams, ...args });
    } catch (error) {
      (0, import_context_utils.reportTelemetryFailure)(error);
    }
  }
  error(message, args) {
    this.log("error", message, args);
  }
  info(message, args) {
    this.log("info", message, args);
  }
  warn(message, args) {
    this.log("warn", message, args);
  }
  debug(message, args) {
    this.log("debug", message, args);
  }
}
//# sourceMappingURL=base-measure-context.js.map
